/*
 * @Author: name
 * @Date: 2021-01-03 02:26:24
 * @Description: 
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: 'HomePage',
    component: () => import('../views/HomePage.vue')
  },
  {
    path: "/homePage",
    name: 'HomePage',
    component: () => import('../views/HomePage.vue')
  },
  {
    path: "/products",
    name: "Products",
    component: () => import('../views/Products.vue')
  },
  {
    path: "/solutions",
    name: "Solutions",
    component: () => import('../views/Solutions.vue')
  },
  {
    path: "/apps",
    name: "Apps",
    component: () => import('../views/Apps.vue')
  },
  // {
  //   path: "/app_ess",
  //   name: "ESS",
  //   component: () => import('../views/ESS.vue')
  // },
  // {
  //   path: "/app_cas",
  //   name: "CAS",
  //   component: () => import('../views/CAS.vue')
  // },
  // {
  //   path: "/app_mea",
  //   name: "MEA",
  //   component: () => import('../views/MEA.vue')
  // },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
